import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();
export default {
    namespaced: true,
    state: {
        isLoading: false,
        saveSections: {},
    },
    getters: {
        saveSections: (state) => {
            return state.saveSections
        },
        isLoading: (state) => {
            return state.isLoading
        },
    },
    actions: {
        async onSetCookies ({ commit }, params) {
            try {
                commit('setIsLoading', true)
                // const response = await axios.get('/api/cookies/set', { params })

                cookies.set(params.key, params.value);
                // if (response && response.success) {
                //     return response.data
                // }

            } catch (error) {
                console.warn(error)
            }
            commit('setIsLoading', false)
        },

        async onGetCookies ({ commit }, key) {
            commit('setIsLoading', true)
            try {
                return await cookies.get(key) ?? {}
            } catch (error) {
                console.warn(error)
            }
            commit('setIsLoading', false)
        },

        async onDeleteCookies ({ commit }, key) {
            try {
                commit('setIsLoading', true)
                cookies.remove(key);
            } catch (error) {
                console.warn(error)
            }
            commit('setIsLoading', false)
        },

    },
    mutations: {
        setIsLoading (state, payload) {
            state.isLoading = payload
        },
    },
}
